import { useLanguage } from "@/contexts/LanguageContext";
import { Instagram, Facebook, ExternalLink } from "lucide-react";
import pltLogo from "@/assets/logos/plt-logo.png";
import dffmLogo from "@/assets/logos/dffm-logo.png";
import corazonLatinoLogo from "@/assets/logos/corazon-latino-logo.png";
const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="relative z-20 py-sm md:py-md bg-forest-700">
      <div className="container mx-auto px-md lg:px-lg">
        {/* Footer Top Row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-sm md:gap-md text-sand-100 mb-6 pb-6 border-b border-sand-100/20">
          {/* Logo */}
          <div className="flex items-center shrink-0">
            <span className="font-semibold text-small whitespace-nowrap">
              © 2025 Your Office Outdoors. All rights reserved.
            </span>
          </div>

          {/* Social links */}
          <div className="flex items-center gap-sm shrink-0">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="p-1.5 hover:text-sunset-500 transition-colors duration-fast"
              aria-label="Instagram"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href="https://www.facebook.com/CoraLatin"
              target="_blank"
              rel="noopener noreferrer"
              className="p-1.5 hover:text-sunset-500 transition-colors duration-fast"
              aria-label="Facebook"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </div>

          {/* Powered by */}
          <div className="text-small text-sand-200 text-jus md:ml-auto">{t("footer.powered")}</div>
        </div>

        {/* Sponsors Row */}
        <div className="flex justify-center items-center gap-8 md:gap-12">
          <a
            href="https://plt.org"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-80 hover:opacity-100 transition-opacity duration-300"
          >
            <img src={pltLogo} alt="Project Learning Tree" className="h-8 md:h-10 w-auto" />
          </a>
          <a
            href="https://dffm.az.gov"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-80 hover:opacity-100 transition-opacity duration-300"
          >
            <img
              src={dffmLogo}
              alt="Arizona Department of Forestry and Fire Management"
              className="h-8 md:h-10 w-auto"
            />
          </a>
          <a
            href="https://www.corazonlatino.us/"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-80 hover:opacity-100 transition-opacity duration-300"
          >
            <img src={corazonLatinoLogo} alt="Corazón Latino" className="h-8 md:h-10 w-auto" />
          </a>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
